import React, { useState, useEffect, Suspense, useRef, useMemo, startTransition, } from "react";
import { prefetchDNS, preconnect } from "react-dom";
import Html from './html';
import { LazyLoadModules } from "./helpers/lazyLoadModules";
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import "./styles/siteStyles.scss";
import './index.scss';
import './cookie.scss';
import { ANALYTICSEVENTS } from "./constants/analyticsEvents";
import logger from "./logger";
import loadable from '@loadable/component';
import NavFocusSkipper from "./components/SkipToMainContent";
import { ErrorBoundary } from "react-error-boundary";
import * as helpers from "./helpers";
import pubsub from "@viewlift/pubsub";
import { loadSiteStyles } from "./styles/helpers";
import { initializeConnection, syncSSEStore } from "./SSE";
import { parseJSON } from "./OnBoarding-V2/utils/parseJSON";
import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';
import { version } from '../package.json';
const afterPaint = (fn) => {
    if (typeof requestIdleCallback !== 'undefined') {
        requestIdleCallback(fn, { timeout: 4000 });
    }
    else {
        setTimeout(fn, 3000);
    }
};
const NotFound404 = React.lazy(() => import("./components/404"));
import CmsMenu from "./components/CmsMenu/index.js";
import PersonalizationBanner from './modules/PersonalizationBanner';
const V2TveLogin = loadable(() => import("./components/AdobeRestV2/V2TveLogin"));
const SplashLoader = loadable(() => import("./modules/SplashScreens"));
const UpgradeWrapper = loadable(() => import("./OnBoarding-V2/utils/UpgradeWrapper/index"));
const LocationServicesModal = loadable(() => import('./components/LocationServicesModal'));
const VerticalMastheadComponent = loadable(() => import('./modules/VerticalMasthead'), { ssr: true });
const MastheadComponent = loadable(() => import('./modules/MastheadModule'), { ssr: true });
export const App = ({ siteConfig, pageData, browserDetails, xApiKey, cachedAPI, apiBaseUrl, sseBaseUrl, analyticsBaseUrl, wssBaseUrl, env, ip, embedCodeToken, toolsUrl, templateUrl, requestId, cssHref, scriptSrcs }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60;
    // React 19 asset-hint APIs: emitted into the streamed <head> during SSR and
    // deduped automatically. Establishes the API/SSE/analytics connections in
    // parallel with the document download instead of waiting for hydration.
    if (apiBaseUrl)
        preconnect(apiBaseUrl, { crossOrigin: 'anonymous' });
    if (sseBaseUrl)
        prefetchDNS(sseBaseUrl);
    if (analyticsBaseUrl)
        prefetchDNS(analyticsBaseUrl);
    const [pageMetaData, setPageData] = useState(pageData);
    const [VLCookieConsent, setVLCookieConsent] = useState(null);
    const [activeSplash, setActiveSplash] = useState(null);
    const [isTveEnabled, setIsTveEnabled] = useState(false);
    const [SnackbarComponent, setSnackbarComponent] = useState(null);
    //const [showMasthead, setShowMasthead] = useState(false)
    //const windowSizeRef:any = useRef({ width: null });
    const [searchParams] = useSearchParams();
    const [isUpgrade, setIsUpgrade] = useState(false);
    const navigate = useNavigate();
    const snackbarRef = useRef(null);
    let previouslyFocusedElement = useRef(null);
    const analyticListenerReady = useRef(null);
    let IntervalInstance;
    const disableVlCookieConsent = (typeof window !== "undefined") ? (((_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsMain) === null || _b === void 0 ? void 0 : _b.privacy) === null || _c === void 0 ? void 0 : _c.disableVlCookieConsent) || false) : false;
    const zipcodeEnabledForPersonalizationChoices = (typeof window !== "undefined") ? (((_f = (_e = (_d = window === null || window === void 0 ? void 0 : window.app_data) === null || _d === void 0 ? void 0 : _d.appcmsMain) === null || _e === void 0 ? void 0 : _e.geoRestrict) === null || _f === void 0 ? void 0 : _f.zipcodeEnabledForPersonalizationChoices) || false) : false;
    const isAuthWithPwdFlow = (typeof window !== "undefined") ? (((_k = (_j = (_h = (_g = window === null || window === void 0 ? void 0 : window.app_data) === null || _g === void 0 ? void 0 : _g.appcmsMain) === null || _h === void 0 ? void 0 : _h.ssoConfig) === null || _j === void 0 ? void 0 : _j.nhl) === null || _k === void 0 ? void 0 : _k.isEnabled) || false) : false;
    const configMessages = (typeof window !== "undefined") ? {
        cookieModalHeadingTitle: (_o = (_m = (_l = window === null || window === void 0 ? void 0 : window.app_data) === null || _l === void 0 ? void 0 : _l.appcmsMain) === null || _m === void 0 ? void 0 : _m.genericMessages) === null || _o === void 0 ? void 0 : _o.cookieModalHeadingTitle,
        cookieModalDescription: (_r = (_q = (_p = window === null || window === void 0 ? void 0 : window.app_data) === null || _p === void 0 ? void 0 : _p.appcmsMain) === null || _q === void 0 ? void 0 : _q.genericMessages) === null || _r === void 0 ? void 0 : _r.cookieModalDescription,
        requiredCookieAccordionTitle: (_u = (_t = (_s = window === null || window === void 0 ? void 0 : window.app_data) === null || _s === void 0 ? void 0 : _s.appcmsMain) === null || _t === void 0 ? void 0 : _t.genericMessages) === null || _u === void 0 ? void 0 : _u.requiredCookieAccordionTitle,
        requiredCookieAccordionDescription: (_x = (_w = (_v = window === null || window === void 0 ? void 0 : window.app_data) === null || _v === void 0 ? void 0 : _v.appcmsMain) === null || _w === void 0 ? void 0 : _w.genericMessages) === null || _x === void 0 ? void 0 : _x.requiredCookieAccordionDescription,
        optionalCookieAccordionTitle: (_0 = (_z = (_y = window === null || window === void 0 ? void 0 : window.app_data) === null || _y === void 0 ? void 0 : _y.appcmsMain) === null || _z === void 0 ? void 0 : _z.genericMessages) === null || _0 === void 0 ? void 0 : _0.optionalCookieAccordionTitle,
        optionalCookieAccordionDescription: (_3 = (_2 = (_1 = window === null || window === void 0 ? void 0 : window.app_data) === null || _1 === void 0 ? void 0 : _1.appcmsMain) === null || _2 === void 0 ? void 0 : _2.genericMessages) === null || _3 === void 0 ? void 0 : _3.optionalCookieAccordionDescription,
        functionalCookieTitle: (_6 = (_5 = (_4 = window === null || window === void 0 ? void 0 : window.app_data) === null || _4 === void 0 ? void 0 : _4.appcmsMain) === null || _5 === void 0 ? void 0 : _5.genericMessages) === null || _6 === void 0 ? void 0 : _6.functionalCookieTitle,
        functionalCookieDescription: (_9 = (_8 = (_7 = window === null || window === void 0 ? void 0 : window.app_data) === null || _7 === void 0 ? void 0 : _7.appcmsMain) === null || _8 === void 0 ? void 0 : _8.genericMessages) === null || _9 === void 0 ? void 0 : _9.functionalCookieDescription,
        performanceCookieTitle: (_12 = (_11 = (_10 = window === null || window === void 0 ? void 0 : window.app_data) === null || _10 === void 0 ? void 0 : _10.appcmsMain) === null || _11 === void 0 ? void 0 : _11.genericMessages) === null || _12 === void 0 ? void 0 : _12.performanceCookieTitle,
        performanceCookieDescription: (_15 = (_14 = (_13 = window === null || window === void 0 ? void 0 : window.app_data) === null || _13 === void 0 ? void 0 : _13.appcmsMain) === null || _14 === void 0 ? void 0 : _14.genericMessages) === null || _15 === void 0 ? void 0 : _15.performanceCookieDescription,
        cookieAcceptBtnLabel: (_18 = (_17 = (_16 = window === null || window === void 0 ? void 0 : window.app_data) === null || _16 === void 0 ? void 0 : _16.appcmsMain) === null || _17 === void 0 ? void 0 : _17.genericMessages) === null || _18 === void 0 ? void 0 : _18.cookieAcceptBtnLabel,
        cookieRejectBtnLabel: (_21 = (_20 = (_19 = window === null || window === void 0 ? void 0 : window.app_data) === null || _19 === void 0 ? void 0 : _19.appcmsMain) === null || _20 === void 0 ? void 0 : _20.genericMessages) === null || _21 === void 0 ? void 0 : _21.cookieRejectBtnLabel,
        cookieSaveSettingsBtnLabel: (_24 = (_23 = (_22 = window === null || window === void 0 ? void 0 : window.app_data) === null || _22 === void 0 ? void 0 : _22.appcmsMain) === null || _23 === void 0 ? void 0 : _23.genericMessages) === null || _24 === void 0 ? void 0 : _24.cookieSaveSettingsBtnLabel,
        cookieSettingsModalTitle: (_27 = (_26 = (_25 = window === null || window === void 0 ? void 0 : window.app_data) === null || _25 === void 0 ? void 0 : _25.appcmsMain) === null || _26 === void 0 ? void 0 : _26.genericMessages) === null || _27 === void 0 ? void 0 : _27.cookieSettingsModalTitle,
        cookieSettingsModalDescription: (_30 = (_29 = (_28 = window === null || window === void 0 ? void 0 : window.app_data) === null || _28 === void 0 ? void 0 : _28.appcmsMain) === null || _29 === void 0 ? void 0 : _29.genericMessages) === null || _30 === void 0 ? void 0 : _30.cookieSettingsModalDescription,
        cookieSettingsMoreInfoTitle: (_33 = (_32 = (_31 = window === null || window === void 0 ? void 0 : window.app_data) === null || _31 === void 0 ? void 0 : _31.appcmsMain) === null || _32 === void 0 ? void 0 : _32.genericMessages) === null || _33 === void 0 ? void 0 : _33.cookieSettingsMoreInfoTitle,
        cookieSettingsMoreInfoDescription: (_36 = (_35 = (_34 = window === null || window === void 0 ? void 0 : window.app_data) === null || _34 === void 0 ? void 0 : _34.appcmsMain) === null || _35 === void 0 ? void 0 : _35.genericMessages) === null || _36 === void 0 ? void 0 : _36.cookieSettingsMoreInfoDescription,
        cookieLetMeChooseButtonLabel: (_39 = (_38 = (_37 = window === null || window === void 0 ? void 0 : window.app_data) === null || _37 === void 0 ? void 0 : _37.appcmsMain) === null || _38 === void 0 ? void 0 : _38.genericMessages) === null || _39 === void 0 ? void 0 : _39.cookieLetMeChooseButtonLabel,
        privacyPolicyLinkLabel: (_42 = (_41 = (_40 = window === null || window === void 0 ? void 0 : window.app_data) === null || _40 === void 0 ? void 0 : _40.appcmsMain) === null || _41 === void 0 ? void 0 : _41.genericMessages) === null || _42 === void 0 ? void 0 : _42.privacyPolicyLinkLabel,
        contactUsLinkLabel: (_45 = (_44 = (_43 = window === null || window === void 0 ? void 0 : window.app_data) === null || _43 === void 0 ? void 0 : _43.appcmsMain) === null || _44 === void 0 ? void 0 : _44.genericMessages) === null || _45 === void 0 ? void 0 : _45.contactUsLinkLabel
    } : {};
    const shouldShowLocationModal = zipcodeEnabledForPersonalizationChoices && isAuthWithPwdFlow;
    let location = useLocation();
    useEffect(() => {
        afterPaint(() => import("./instrumentation").then(({ Instrumentation }) => Instrumentation.initSentry()));
    }, []);
    useEffect(() => {
        var _a, _b, _c, _d;
        if (typeof window === "undefined")
            return;
        const isAdobeEnabled = (_d = (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsPlatform) === null || _b === void 0 ? void 0 : _b.analytics) === null || _c === void 0 ? void 0 : _c.adobeConfig) === null || _d === void 0 ? void 0 : _d.enabled;
        if (!isAdobeEnabled)
            return;
        afterPaint(() => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            const appMeasurementUrl = (_d = (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsPlatform) === null || _b === void 0 ? void 0 : _b.analytics) === null || _c === void 0 ? void 0 : _c.adobeConfig) === null || _d === void 0 ? void 0 : _d.appMeasurement;
            const mediaSdkUrl = (_h = (_g = (_f = (_e = window === null || window === void 0 ? void 0 : window.app_data) === null || _e === void 0 ? void 0 : _e.appcmsPlatform) === null || _f === void 0 ? void 0 : _f.analytics) === null || _g === void 0 ? void 0 : _g.adobeConfig) === null || _h === void 0 ? void 0 : _h.mediaSdk;
            const loadScript = (src) => new Promise((resolve, reject) => {
                const script = document.createElement("script");
                script.src = src;
                script.async = true;
                document.body.appendChild(script);
                script.onload = () => resolve();
                script.onerror = (e) => reject(e);
            });
            loadScript(appMeasurementUrl)
                .then(() => loadScript(mediaSdkUrl))
                .then(() => {
                var _a, _b;
                window.adobeMediaScriptLoaded = true;
                const Media = (_a = window === null || window === void 0 ? void 0 : window.ADB) === null || _a === void 0 ? void 0 : _a.Media;
                const MediaConfig = (_b = window === null || window === void 0 ? void 0 : window.ADB) === null || _b === void 0 ? void 0 : _b.MediaConfig;
                if (Media && MediaConfig) {
                    import("./AdobeAnalytics/adobeAnalytics").then(({ setupMediaHeartbeat }) => {
                        setupMediaHeartbeat(Media, MediaConfig);
                    });
                }
            })
                .catch((err) => console.error("Adobe Analytics load error:", err));
        });
    }, []);
    useEffect(() => {
        if (disableVlCookieConsent) {
            afterPaint(() => {
                let oneTrustInterval = null;
                oneTrustInterval = setInterval(function () {
                    var _a;
                    if ((_a = window === null || window === void 0 ? void 0 : window.OneTrust) === null || _a === void 0 ? void 0 : _a.IsAlertBoxClosed()) {
                        if (oneTrustInterval)
                            clearInterval(oneTrustInterval);
                        pubsub.publish("one-trust-setup", true);
                    }
                }, 3000);
            });
        }
    }, []);
    useEffect(() => {
        afterPaint(async () => {
            var _a, _b, _c, _d;
            const { default: Cookies } = await import("js-cookie");
            const importVLCookieConsent = async () => {
                var _a;
                try {
                    const module = await import('@viewlift/cookie-consent/vlCookieConsent/esm/App');
                    if ('VLCookieConsent' in module) {
                        const VLCookieConsent = module.VLCookieConsent;
                        startTransition(() => setVLCookieConsent(() => VLCookieConsent));
                    }
                    else if ('default' in module) {
                        const moduleWithDefault = module;
                        if (moduleWithDefault && moduleWithDefault.default) {
                            const VLCookieConsent = moduleWithDefault.default;
                            startTransition(() => setVLCookieConsent(() => VLCookieConsent));
                        }
                    }
                    else {
                        logger(`Invalid VLCookieConsent module structure: ${module}`, "error");
                    }
                }
                catch (error) {
                    logger(`Error importing VLCookieConsent: ${error}`, "error");
                }
                if (Cookies.get("cc_cookie")) {
                    const getCookie = JSON.parse(Cookies.get("cc_cookie"));
                    if (((_a = getCookie === null || getCookie === void 0 ? void 0 : getCookie.level) === null || _a === void 0 ? void 0 : _a.includes("performanceCookie")) && !window.fireGaEvents) {
                        window.fireGaEvents = true;
                        helpers.initGTM();
                    }
                }
            };
            const externalAuthUrl = helpers.isExternalAuthUrl() || null;
            let isAppAccessing = (!externalAuthUrl && helpers.getQueryParams(window.location.href)) || null;
            const isKetchEnabled = ((_d = (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsPlatform) === null || _b === void 0 ? void 0 : _b.privacy) === null || _c === void 0 ? void 0 : _c.ketchCookie) === null || _d === void 0 ? void 0 : _d.enable) || false;
            if (typeof (window) !== undefined && !(window.location.href.indexOf("embed/player") > -1) && !isAppAccessing) {
                analyticListenerReady.current = import("./analyticListener").then(({ listenAnalyticEvents, listenFBEvents, listenConviva }) => {
                    listenAnalyticEvents();
                    listenFBEvents();
                    listenConviva();
                });
                if (!externalAuthUrl) {
                    if (!disableVlCookieConsent) {
                        importVLCookieConsent();
                    }
                    else if (isKetchEnabled) {
                        const { default: ketchCookieConsent } = await import('./components/CookieConsent/ketch.js');
                        ketchCookieConsent();
                        window.fireGaEvents = true;
                        helpers.initGTM();
                    }
                    else {
                        pubsub.subscribe("one-trust-setup", (data) => {
                            let OptanonConsent = Cookies.get("OptanonConsent");
                            const params = new URLSearchParams(OptanonConsent);
                            const parsedData = Object.fromEntries(params.entries());
                            let groups = helpers.convertToJSON(parsedData === null || parsedData === void 0 ? void 0 : parsedData.groups);
                            if (groups) {
                                if (groups['C0004'] && !window.fireGaEvents) {
                                    window.fireGaEvents = true;
                                    helpers.initGTM();
                                }
                            }
                        });
                    }
                }
            }
            helpers.subscriptionData();
        });
    }, []);
    useEffect(() => {
        var _a;
        if (typeof (window) !== undefined && ((_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsMain.features.embeddedCode)) {
            afterPaint(() => {
                const isAppAccessing = helpers.getQueryParams(window.location.href) || null;
                if (isAppAccessing) {
                    document.body.classList.add("remove-oneTrust");
                }
                helpers.embedCode();
            });
        }
    }, []);
    function initDatadog() {
        var _a, _b, _c;
        if (typeof window === "undefined")
            return;
        const dataDogConfig = (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsPlatform) === null || _b === void 0 ? void 0 : _b.observability) === null || _c === void 0 ? void 0 : _c.datadogConfig;
        const { enable, applicationId, clientToken, datadogSite, preferredServiceName, environment } = dataDogConfig || {};
        // early return if Datadog RUM is not enabled in the configuration
        if (!enable)
            return;
        // Validate required Datadog configuration
        const missingConfigs = [
            !applicationId && "applicationId",
            !clientToken && "clientToken",
            !datadogSite && "datadogSite",
            !preferredServiceName && "preferredServiceName",
            !environment && "environment",
        ].filter(Boolean);
        if (missingConfigs.length > 0) {
            console.error("[Datadog] Initialize Failed - Incorrect Configuration. Missing:", missingConfigs.join(", "));
            return;
        }
        // Initialize Datadog RUM
        try {
            datadogRum.init({
                applicationId,
                clientToken,
                site: datadogSite,
                service: preferredServiceName,
                env: environment,
                version: version || "0.0.1",
                sessionSampleRate: 100,
                sessionReplaySampleRate: 20,
                trackResources: true,
                trackUserInteractions: true,
                trackLongTasks: true,
                plugins: [reactPlugin({ router: false })],
            });
        }
        catch (error) {
            console.error("[Datadog] Failed to initialize:", error);
        }
    }
    useEffect(() => {
        initDatadog();
    }, []);
    useEffect(() => {
        if (!shouldShowLocationModal)
            return;
        afterPaint(async () => {
            try {
                const { checkTeamsAvailability } = await import("./helpers/checkTeamsAvailability");
                const isTeamsAvailable = await checkTeamsAvailability();
                if (isTeamsAvailable) {
                    pubsub.publish('hide-location-services-modal');
                }
                else {
                    pubsub.publish('show-location-services-modal');
                }
            }
            catch (error) {
                console.error('Error checking teams availability:', error);
            }
        });
    }, []);
    const checkForIsRedirected = async () => {
        var _a, _b;
        const [{ getStorageItem, setStorageItem }, { default: Cookies }] = await Promise.all([
            import("./helpers/storageManager.js"),
            import("js-cookie"),
        ]);
        let redirected = getStorageItem("isRedirected");
        let comparePath = (_a = redirected === null || redirected === void 0 ? void 0 : redirected.path) === null || _a === void 0 ? void 0 : _a.split("?");
        comparePath = (comparePath === null || comparePath === void 0 ? void 0 : comparePath.length) ? comparePath[0] : redirected === null || redirected === void 0 ? void 0 : redirected.path;
        if (location.pathname === comparePath || (location === null || location === void 0 ? void 0 : location.pathname) === "/") {
            setStorageItem("isRedirected", { ...redirected, redirect: false, isDetailPage: false, isUpgradePlan: false, isCheckout: false });
            if (!((_b = redirected === null || redirected === void 0 ? void 0 : redirected.contentSubscriptionFlow) === null || _b === void 0 ? void 0 : _b.enabled) || location.pathname === (redirected === null || redirected === void 0 ? void 0 : redirected.path)) {
                sessionStorage.removeItem("contentPlanIds");
                sessionStorage.removeItem("toShowTve");
            }
            sessionStorage.removeItem('isUpgradeAvailable');
        }
        if (location.pathname != '/redeem-authentication') {
            Cookies.set('RedirectToRedeem', false);
        }
    };
    const redirectToPath = (data) => {
        const navigateToExternalUrl = helpers.isNavigateToExternalUrl();
        if (navigateToExternalUrl) {
            window.location.href = navigateToExternalUrl;
            return;
        }
        else {
            navigate(data);
        }
    };
    useEffect(() => {
        var _a;
        if (sessionStorage.getItem('reloadAfterNavigation') === 'true') {
            sessionStorage.removeItem('reloadAfterNavigation');
            window.location.reload();
            return;
        }
        pubsub.subscribe('redirect', redirectToPath);
        const searchTerm = ((_a = location.state) === null || _a === void 0 ? void 0 : _a.searchTerm) || null;
        // Don't publish 'apploading: false' here — pageClientQueryData publishes it
        // on its own when the fetch resolves (success, error, or timeout). Hiding
        // the loader synchronously before the fetch completes is what makes
        // navigations look blank/stale between URL change and new page render.
        helpers.pageClientQueryData(pageData, setPageData, { status: false }, searchTerm);
        loadSiteStyles();
        let bodyTag = document.getElementsByTagName("body");
        if (bodyTag.length > 0) {
            bodyTag[0].style.overflowY = "unset";
            bodyTag[0].style.position = "unset";
        }
        afterPaint(async () => {
            var _a, _b, _c, _d;
            const { initializeWebWorker } = await import("../registerSW.js");
            initializeWebWorker();
            sessionStorage.setItem("transactionStarted", JSON.stringify(false));
            let isCheckoutInitiate = parseJSON(sessionStorage.getItem('checkout-initiate') || '');
            if (isCheckoutInitiate) {
                sessionStorage.removeItem('checkout-initiate');
                let currentStoredPlan = parseJSON(sessionStorage.getItem('currentPlan') || '');
                const checkoutInitPageDetails = parseJSON(sessionStorage.getItem('checkoutInitPageData') || '');
                let eventData = {
                    "pageUrl": checkoutInitPageDetails === null || checkoutInitPageDetails === void 0 ? void 0 : checkoutInitPageDetails.pageUrl,
                    "monetizationType": currentStoredPlan === null || currentStoredPlan === void 0 ? void 0 : currentStoredPlan.type,
                    "message": 'page change'
                };
                pubsub.publish('user-analytics', { ename: ANALYTICSEVENTS.NEW_ONBOARDING_CHECKOUT_CANCELED, data: eventData });
                helpers.handleStatusGaCalls({ eventName: 'checkout_cancellation', subSection: null, type: 'cancellation', reason: 'page change', status: 'cancellation', action: 'Cancel', paymentStatus: null, eventCategory: 'Checkout', section: 'checkout', additionalLabel: null });
            }
            if ((pageData === null || pageData === void 0 ? void 0 : pageData.path) != '/tos' && (pageData === null || pageData === void 0 ? void 0 : pageData.path) != '/privacy-policy' && (pageData === null || pageData === void 0 ? void 0 : pageData.path) != '/offers' && (pageData === null || pageData === void 0 ? void 0 : pageData.path) != '/agreement' && (pageData === null || pageData === void 0 ? void 0 : pageData.path) != '/checkout')
                helpers.checkVppaCompliance();
            checkForIsRedirected();
            syncSSEStore();
            if ((location === null || location === void 0 ? void 0 : location.pathname) === '/') {
                sessionStorage.removeItem("contentPlanIds");
                sessionStorage.removeItem("toShowTve");
                sessionStorage.removeItem("splashLoginEmail");
                sessionStorage.removeItem("splashSignupEmail");
            }
            const isTveEnabled = helpers.isTveOnlyLoginEnabled();
            startTransition(() => setIsTveEnabled(isTveEnabled));
            if (isTveEnabled && (location.pathname == '/authentication' || location.pathname == '/checkout')) {
                navigate('/');
            }
            if (typeof (window) !== undefined && ((_d = (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsPlatform) === null || _b === void 0 ? void 0 : _b.analytics) === null || _c === void 0 ? void 0 : _c.convivaConfig) === null || _d === void 0 ? void 0 : _d.enabled)) {
                pubsub.publish('conviva-page-change', null);
            }
        });
    }, [location]);
    useEffect(() => {
        if (typeof window === "undefined")
            return;
        let timeout = null;
        afterPaint(() => {
            try {
                pubsub.subscribe('page-modules-updated', (data) => {
                    var _a, _b, _c;
                    if (!data || !data.updatedModules || data.updatedModules.length === 0 || !data.pageId || !data.site)
                        return console.warn('Invalid data received for page-modules-updated event');
                    if (data.pageId !== ((_a = pageMetaData === null || pageMetaData === void 0 ? void 0 : pageMetaData.page) === null || _a === void 0 ? void 0 : _a.id))
                        return console.info('User is not on the same page where modules are updated');
                    const currentModuleIds = ((_c = (_b = pageMetaData === null || pageMetaData === void 0 ? void 0 : pageMetaData.page) === null || _b === void 0 ? void 0 : _b.modules) === null || _c === void 0 ? void 0 : _c.map((mod) => mod.id)) || [];
                    const isModuleUpdated = data.updatedModules.some((moduleId) => currentModuleIds.includes(moduleId));
                    if (!isModuleUpdated)
                        return console.info('No matching modules found on the current page for the updated modules');
                    const randomDelay = Math.floor(Math.random() * (50000 - 5000 + 1)) + 5000;
                    console.info(`Received page-modules-updated event. Fetching updated module data in ${randomDelay} ms...`);
                    if (timeout)
                        clearTimeout(timeout);
                    timeout = setTimeout(() => {
                        console.info('Fetching updated module data after page-modules-updated event...');
                        helpers.pageClientQueryData(pageMetaData, setPageData, { status: false }, null, data.updatedModules, true);
                    }, randomDelay);
                });
            }
            catch (err) {
                console.error(`Error subscribing to page-modules-updated event: ${err}`);
            }
        });
        return () => {
            if (timeout)
                clearTimeout(timeout);
        };
    }, []);
    const handleUserCreated = async (data) => {
        var _a;
        if (data === null || data === void 0 ? void 0 : data.status) {
            initializeConnection({
                site: (_a = siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.site) === null || _a === void 0 ? void 0 : _a.siteInternalName,
                sseBaseUrl: sseBaseUrl
            });
            const { unsubscribeUserCreated } = await import("./OnBoarding-V2/Events/utils.events");
            unsubscribeUserCreated((data) => handleUserCreated(data));
        }
    };
    const clevertapInit = async () => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        const [{ getStorageItem }, { requestUserPermission, anonymousUserPushNotification }] = await Promise.all([
            import("./helpers/storageManager.js"),
            import("../registerSW.js"),
        ]);
        const AuthenticationStore = getStorageItem('AuthenticationStore');
        let userInfo = AuthenticationStore === null || AuthenticationStore === void 0 ? void 0 : AuthenticationStore.user;
        if (userInfo === null || userInfo === void 0 ? void 0 : userInfo.id) {
            var subscriptionData = userInfo.subscription || {};
            var userProfile = {
                'Name': userInfo.name,
                'Email': userInfo.email,
                'Identity': userInfo.userId,
                'Phone': userInfo && userInfo.phoneNumber ? ((typeof userInfo.phoneNumber === 'string' && (userInfo.phoneNumber.charAt(0) !== '+')) ? JSON.parse(userInfo.phoneNumber) : userInfo.phoneNumber) : "",
                'User Status': userInfo.isSubscribed ? 'Subscribed' : 'Registered and Never Subscribed',
                'registration_method': userInfo.provider,
                'registration_platform': userInfo.registerdVia && helpers.capitalize(userInfo.registerdVia.split('_')[0]),
                'registration_date': helpers.getUnixTimestamp((userInfo.registeredOn && userInfo.registeredOn.split("T")[0]) || null),
                'registration_country': userInfo.country,
                'MSG-whatsapp': userInfo && userInfo.whatsappConsent ? userInfo.whatsappConsent : false,
                'MSG-email': userInfo && (userInfo === null || userInfo === void 0 ? void 0 : userInfo.emailConsent) ? userInfo.emailConsent : false,
            };
            if (userInfo.isSubscribed && subscriptionData && subscriptionData.subscriptionInfo) {
                Object.assign(userProfile, {
                    'paymentHandler': ((_a = subscriptionData === null || subscriptionData === void 0 ? void 0 : subscriptionData.subscriptionInfo) === null || _a === void 0 ? void 0 : _a.paymentHandler) || null,
                    'subscriptionStartDate': helpers.getUnixTimestamp((((_b = subscriptionData === null || subscriptionData === void 0 ? void 0 : subscriptionData.subscriptionInfo) === null || _b === void 0 ? void 0 : _b.subscriptionStartDate) && ((_c = subscriptionData === null || subscriptionData === void 0 ? void 0 : subscriptionData.subscriptionInfo) === null || _c === void 0 ? void 0 : _c.subscriptionStartDate.split("T")[0])) || null),
                    'subscriptionEndDate': helpers.getUnixTimestamp((((_d = subscriptionData === null || subscriptionData === void 0 ? void 0 : subscriptionData.subscriptionInfo) === null || _d === void 0 ? void 0 : _d.subscriptionEndDate) && ((_e = subscriptionData === null || subscriptionData === void 0 ? void 0 : subscriptionData.subscriptionInfo) === null || _e === void 0 ? void 0 : _e.subscriptionEndDate.split("T")[0])) || null),
                    'discountAmount': ((_f = subscriptionData === null || subscriptionData === void 0 ? void 0 : subscriptionData.subscriptionInfo) === null || _f === void 0 ? void 0 : _f.planAmount) || null,
                    'paymentPlanID': ((_g = subscriptionData === null || subscriptionData === void 0 ? void 0 : subscriptionData.subscriptionInfo) === null || _g === void 0 ? void 0 : _g.planId) || null,
                    'freeTrial': ((_h = subscriptionData === null || subscriptionData === void 0 ? void 0 : subscriptionData.subscriptionInfo) === null || _h === void 0 ? void 0 : _h.freeTrial) ? 'Yes' : 'No',
                    'country': ((_j = subscriptionData === null || subscriptionData === void 0 ? void 0 : subscriptionData.subscriptionInfo) === null || _j === void 0 ? void 0 : _j.countryCode) || null,
                    'currency': ((_k = subscriptionData === null || subscriptionData === void 0 ? void 0 : subscriptionData.subscriptionInfo) === null || _k === void 0 ? void 0 : _k.currencyCode) || null,
                    'amount': ((_l = subscriptionData === null || subscriptionData === void 0 ? void 0 : subscriptionData.subscriptionInfo) === null || _l === void 0 ? void 0 : _l.planAmount) || null,
                });
            }
            import("./clevertap")
                .then(({ initCleverTap, addUserProfile }) => {
                return Promise.resolve(initCleverTap())
                    .then(() => Promise.resolve(addUserProfile('Site', userProfile, true)));
            })
                .catch(error => {
                console.error("Error executing clevertap functions:", error);
            });
            requestUserPermission();
        }
        else {
            import("./clevertap")
                .then(({ initCleverTap }) => {
                return Promise.resolve(initCleverTap())
                    .then(() => anonymousUserPushNotification === null || anonymousUserPushNotification === void 0 ? void 0 : anonymousUserPushNotification());
            })
                .catch(error => {
                console.error("Error executing clevertap functions:", error);
            });
        }
    };
    const initiateInterval = async () => {
        var _a;
        const { BroadcastChannel } = await import("broadcast-channel");
        let storageName = `${(_a = siteConfig.site) === null || _a === void 0 ? void 0 : _a.siteInternalName}-lastTimestamp`;
        IntervalInstance = setInterval(() => {
            var _a, _b;
            let lastTimestamp = localStorage.getItem(storageName);
            let broadcastHeartbeat = sessionStorage.getItem('broadcast-heartbeat');
            let currentTime = new Date().getTime();
            const channelName = `${(_a = siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.site) === null || _a === void 0 ? void 0 : _a.siteInternalName}-channel`;
            const bc = new BroadcastChannel(channelName);
            if ((!broadcastHeartbeat || (currentTime - parseInt(broadcastHeartbeat)) > 20000) && lastTimestamp && (currentTime - parseInt(lastTimestamp)) < 20000) {
                helpers.listenToChannel(bc);
            }
            if (!lastTimestamp || (currentTime - parseInt(lastTimestamp)) > 20000) {
                initializeConnection({
                    site: (_b = siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.site) === null || _b === void 0 ? void 0 : _b.siteInternalName,
                    sseBaseUrl: sseBaseUrl
                });
            }
        }, 20000);
    };
    useEffect(() => {
        afterPaint(() => clevertapInit());
    }, []);
    useEffect(() => {
        afterPaint(async () => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            const [{ default: Cookies }, { BroadcastChannel }, { registerCustomSW }, { pushAdobeAnalyticsData }, { getStorageItem }, { subscribeUserCreated }] = await Promise.all([
                import("js-cookie"),
                import("broadcast-channel"),
                import("../registerSW.js"),
                import("./AdobeAnalytics/AdobeExtention.js"),
                import("./helpers/storageManager.js"),
                import("./OnBoarding-V2/Events/utils.events"),
            ]);
            let isTveAuthenticated = helpers.handleQueryUrls();
            registerCustomSW();
            if (typeof window !== 'undefined' && !helpers.isContentPage()) {
                helpers.setPageTree();
                if (isTveAuthenticated)
                    return;
                pushAdobeAnalyticsData({ eventName: "Page Load", config: { type: "page load" } });
            }
            let storageName = `${(_a = siteConfig.site) === null || _a === void 0 ? void 0 : _a.siteInternalName}-lastTimestamp`;
            let lastTimestamp = localStorage.getItem(storageName);
            let currentTime = new Date().getTime();
            const channelName = `${(_b = siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.site) === null || _b === void 0 ? void 0 : _b.siteInternalName}-channel`;
            const bc = new BroadcastChannel(channelName);
            const adobeVersion = ((_e = (_d = (_c = window === null || window === void 0 ? void 0 : window.app_data) === null || _c === void 0 ? void 0 : _c.appcmsPlatform) === null || _d === void 0 ? void 0 : _d.tveSettings) === null || _e === void 0 ? void 0 : _e.version) || "v1";
            if (!lastTimestamp || (currentTime - parseInt(lastTimestamp)) > 20000) {
                initializeConnection({
                    site: (_f = siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.site) === null || _f === void 0 ? void 0 : _f.siteInternalName,
                    sseBaseUrl: sseBaseUrl
                });
                initiateInterval();
            }
            else {
                bc.postMessage("ping");
                helpers.listenToChannel(bc);
                initiateInterval();
                logger("joined a existing channel", "info");
            }
            (analyticListenerReady.current || Promise.resolve()).then(() => {
                helpers.handlePageViewEvent(pageData, { status: false });
            });
            helpers.listenDisposeCookies();
            helpers.listenDeviceRemoved();
            if (window && typeof (window) !== undefined) {
                const store = getStorageItem('AuthenticationStore');
                let token = Cookies.get('token') && JSON.parse(Cookies.get('token'));
                if ((_g = store === null || store === void 0 ? void 0 : store.user) === null || _g === void 0 ? void 0 : _g.userId) {
                    helpers.handleUserTransactions();
                    if (!(token === null || token === void 0 ? void 0 : token.refreshToken))
                        helpers.fireLogout();
                    if (helpers.handleSeviceTypes().TVE && adobeVersion == 'v1') {
                        import('./helpers/loadTve').then(async (module) => {
                            let loadtve = module.default;
                            await loadtve();
                        });
                    }
                }
                helpers.handleUserLogout((_h = store === null || store === void 0 ? void 0 : store.user) === null || _h === void 0 ? void 0 : _h.userId);
            }
            helpers.fetchAndSetupPlanGroups();
            subscribeUserCreated((data) => handleUserCreated(data));
        });
        return (() => {
            clearInterval(IntervalInstance);
        });
    }, []);
    useEffect(() => {
        afterPaint(async () => {
            const queryString = document.location.search.slice(1);
            if (queryString.includes('utm_')) {
                import('./utm').then((utmFunc) => {
                    let { utm } = utmFunc;
                    utm();
                });
            }
            const [{ isBrazeEnabled }, { getStorageItem }] = await Promise.all([
                import("../registerSW.js"),
                import("./helpers/storageManager.js"),
            ]);
            const brazeObj = isBrazeEnabled();
            if (brazeObj.enabled) {
                import(
                /* webpackExports: ["initialize", "openSession","requestPushPermission","isPushSupported","subscribeToInAppMessage","isPushPermissionGranted","isPushBlocked","InAppMessage","showInAppMessage","automaticallyShowInAppMessages"] */
                "@braze/web-sdk").then(async ({ initialize, openSession, requestPushPermission, isPushSupported, automaticallyShowInAppMessages, isPushPermissionGranted, isPushBlocked, changeUser, getUser }) => {
                    var _a, _b, _c, _d;
                    initialize(brazeObj === null || brazeObj === void 0 ? void 0 : brazeObj.apiKey, {
                        baseUrl: brazeObj === null || brazeObj === void 0 ? void 0 : brazeObj.baseUrl,
                        enableLogging: true,
                        manageServiceWorkerExternally: true
                    });
                    requestPushPermission();
                    automaticallyShowInAppMessages();
                    let store = getStorageItem('AuthenticationStore');
                    let userId = (_a = store === null || store === void 0 ? void 0 : store.user) === null || _a === void 0 ? void 0 : _a.userId;
                    if (userId && typeof changeUser === 'function') {
                        changeUser(userId);
                        if (((_b = store === null || store === void 0 ? void 0 : store.user) === null || _b === void 0 ? void 0 : _b.email) && typeof getUser === 'function')
                            (_c = getUser()) === null || _c === void 0 ? void 0 : _c.setEmail((_d = store === null || store === void 0 ? void 0 : store.user) === null || _d === void 0 ? void 0 : _d.email);
                    }
                    else {
                        pubsub.subscribe('isAuthenticated', (data) => {
                            var _a;
                            if (((data === null || data === void 0 ? void 0 : data.id) || (data === null || data === void 0 ? void 0 : data.userId)) && typeof changeUser === 'function')
                                changeUser((data === null || data === void 0 ? void 0 : data.id) || (data === null || data === void 0 ? void 0 : data.userId));
                            if ((data === null || data === void 0 ? void 0 : data.email) && typeof getUser === 'function') {
                                (_a = getUser()) === null || _a === void 0 ? void 0 : _a.setEmail(data === null || data === void 0 ? void 0 : data.email);
                            }
                        });
                    }
                    openSession();
                    if (typeof window !== "undefined") {
                        window.addEventListener("beforeunload", (evt) => {
                            console.log("App Session End");
                            import('./helpers/trackAnalytics')
                                .then(({ trackBrazeEvents }) => {
                                trackBrazeEvents('App Session End', true);
                            });
                        });
                    }
                })
                    .catch((err) => {
                    console.log(err, "error in initialising braze sdk");
                });
            }
        });
    }, []);
    useEffect(() => {
        afterPaint(() => {
            var _a, _b, _c, _d;
            if ('serviceWorker' in navigator) {
                (_a = navigator.serviceWorker.controller) === null || _a === void 0 ? void 0 : _a.postMessage({ type: 'app_data', payload: (_d = (_c = (_b = window === null || window === void 0 ? void 0 : window.app_data) === null || _b === void 0 ? void 0 : _b.appcmsMain) === null || _c === void 0 ? void 0 : _c.analytics) === null || _d === void 0 ? void 0 : _d.firebaseConfig });
            }
            if (typeof window !== "undefined") {
                import('./fetchBulkEntitlement').then(({ getBulkEntitlementData }) => {
                    getBulkEntitlementData();
                });
            }
        });
    }, []);
    // useEffect(() => {
    //   window.addEventListener('load', () => {
    //     setTimeout(() => {
    //       const entries = performance.getEntriesByType('resource') as PerformanceResourceTiming[];
    //       const SLOW_ASSET_THRESHOLD = 900; // ms
    //       const slowAssets = entries
    //         .filter(entry =>
    //           entry.initiatorType !== 'xmlhttprequest' && entry.duration > SLOW_ASSET_THRESHOLD
    //         )
    //         .map(entry => ({
    //           name: entry.name,
    //           initiatorType: entry.initiatorType,
    //           transferSize: entry.transferSize,
    //           duration: entry.duration,
    //         }));
    //         const vitals = {
    //           LCP: performance.getEntriesByName('largest-contentful-paint')[0]?.startTime,
    //           FID: (performance.getEntriesByName('first-input')[0] as PerformanceEventTiming)?.processingStart,
    //           CLS: performance.getEntriesByType('layout-shift')
    //           .reduce((a, b) => a + (b as LayoutShift).value, 0),
    //           slowAssets : slowAssets
    //         };
    //       if (slowAssets.length > 0) {
    //         navigator.sendBeacon('/performance', JSON.stringify(vitals));
    //       }
    //     }, 0);
    //   });
    // }, []);
    // const lcp = useRef<number | undefined>();
    // const fid = useRef<number | undefined>();
    // const cls = useRef(0);
    // useEffect(() => {
    //   let lcpObserver: PerformanceObserver;
    //   let fidObserver: PerformanceObserver;
    //   let clsObserver: PerformanceObserver;
    //   if ('PerformanceObserver' in window) {
    //     // LCP
    //     lcpObserver = new PerformanceObserver((list) => {
    //       const entries = list.getEntries();
    //       const lastEntry = entries[entries.length - 1];
    //       lcp.current = lastEntry.startTime;
    //     });
    //     lcpObserver.observe({ type: 'largest-contentful-paint', buffered: true });
    //     // FID
    //     fidObserver = new PerformanceObserver((list) => {
    //       const entry = list.getEntries()[0] as PerformanceEventTiming;
    //       if (entry) {
    //         fid.current = entry.processingStart - entry.startTime;
    //       }
    //     });
    //     fidObserver.observe({ type: 'first-input', buffered: true });
    //     // CLS
    //     clsObserver = new PerformanceObserver((list) => {
    //       for (const entry of list.getEntries() as LayoutShift[]) {
    //         if (!entry.hadRecentInput) {
    //           cls.current += entry.value;
    //         }
    //       }
    //     });
    //     clsObserver.observe({ type: 'layout-shift', buffered: true });
    //   }
    //   window.addEventListener('load', () => {
    //     setTimeout(() => {
    //       const entries = performance.getEntriesByType('resource') as PerformanceResourceTiming[];
    //       const SLOW_ASSET_THRESHOLD = 900;
    //       const slowAssets = entries
    //         .filter(entry =>
    //           entry.initiatorType !== 'xmlhttprequest' && entry.duration > SLOW_ASSET_THRESHOLD
    //         )
    //         .map(entry => ({
    //           name: entry.name,
    //           initiatorType: entry.initiatorType,
    //           transferSize: entry.transferSize,
    //           duration: entry.duration,
    //         }));
    //       const vitals = {
    //         LCP: lcp.current,
    //         FID: fid.current,
    //         CLS: cls.current,
    //         slowAssets,
    //       };
    //       if (slowAssets.length > 0) {
    //         try {
    //           const payload = JSON.stringify(vitals);
    //           console.log('[Vitals Payload]', payload);
    //           const sent = navigator.sendBeacon('/performance', payload);
    //           console.log('[Beacon Sent]', sent); // Should log `true`
    //         } catch (err) {
    //           console.error('[Beacon Error]', err);
    //         }
    //       }
    //     }, 0);
    //   });
    //   return () => {
    //     lcpObserver?.disconnect();
    //     fidObserver?.disconnect();
    //     clsObserver?.disconnect();
    //   };
    // }, []);
    useEffect(() => {
        if (typeof window === "undefined")
            return;
        import("./components/Snackbar").then((component) => {
            startTransition(() => setSnackbarComponent(() => component.default));
            helpers.verifyMagicLink();
        });
    }, []);
    useEffect(() => {
        if (typeof window === undefined)
            return;
        pubsub.subscribe("magic-link", (data) => {
            var _a;
            (_a = snackbarRef === null || snackbarRef === void 0 ? void 0 : snackbarRef.current) === null || _a === void 0 ? void 0 : _a.openSnackbar({ message: ((data === null || data === void 0 ? void 0 : data.message) && JSON.parse(data === null || data === void 0 ? void 0 : data.message)), type: (data === null || data === void 0 ? void 0 : data.success) ? "success" : "error" }, 5000);
        });
    }, []);
    useEffect(() => {
        function loadSplash() {
            var _a, _b, _c, _d;
            const splashConfig = (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsMain) === null || _b === void 0 ? void 0 : _b.splashConfig;
            if (!splashConfig)
                return;
            const isObject = (typeof splashConfig === 'object' && !Array.isArray(splashConfig) && splashConfig !== null) ? true : false;
            if (!isObject)
                return;
            if (((_c = Object.keys(splashConfig)) === null || _c === void 0 ? void 0 : _c.length) <= 0)
                return;
            const activeSplash = (_d = Object.keys(splashConfig)) === null || _d === void 0 ? void 0 : _d.find((splash) => { var _a; return (((_a = splashConfig[splash]) === null || _a === void 0 ? void 0 : _a.isActive) ? splash : null); });
            if (!activeSplash)
                return false;
            startTransition(() => setActiveSplash(activeSplash));
        }
        loadSplash();
        return () => { };
    }, []);
    useEffect(() => {
        async function isUserAvailable(planId) {
            var _a, _b;
            const { isSubscribed, user } = await helpers.fetchUserDetails();
            if (planId && user && isSubscribed) {
                let userPlanId = (_b = (_a = user === null || user === void 0 ? void 0 : user.subscription) === null || _a === void 0 ? void 0 : _a.subscriptionInfo) === null || _b === void 0 ? void 0 : _b.planId;
                if (planId !== userPlanId) {
                    const planDetails = await helpers.getPlanByPlanId(planId);
                    if (planDetails && (planDetails === null || planDetails === void 0 ? void 0 : planDetails.length)) {
                        const plan = helpers.structuredPlan(planDetails[0]);
                        sessionStorage.setItem('currentPlan', JSON.stringify(plan));
                        setIsUpgrade(true);
                    }
                }
            }
        }
        if (window && typeof (window) !== undefined) {
            const queryPlanId = searchParams.get('planId') || '';
            const popup = searchParams.get('popup') || '';
            if (location.pathname === "/" && queryPlanId && popup == 'upgradeSubscription') {
                isUserAvailable(queryPlanId);
                pubsub.subscribe("hide-upgrade-popup", (data) => {
                    if (data)
                        setIsUpgrade(false);
                });
            }
        }
    }, [location]);
    let pageSchema = {};
    const publisher = (_46 = siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.appcmsMain) === null || _46 === void 0 ? void 0 : _46.companyName;
    const publisherLogo = ((_48 = (_47 = siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.appcmsPlatform) === null || _47 === void 0 ? void 0 : _47.images) === null || _48 === void 0 ? void 0 : _48.desktopLogo) ? ((_50 = (_49 = siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.appcmsPlatform) === null || _49 === void 0 ? void 0 : _49.images) === null || _50 === void 0 ? void 0 : _50.desktopLogo) + '?impolicy=resize&w=960&h=540' : "";
    pageSchema = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": ((_52 = (_51 = pageMetaData === null || pageMetaData === void 0 ? void 0 : pageMetaData.page) === null || _51 === void 0 ? void 0 : _51.metadataMap) === null || _52 === void 0 ? void 0 : _52.title) || ((_53 = pageMetaData === null || pageMetaData === void 0 ? void 0 : pageMetaData.page) === null || _53 === void 0 ? void 0 : _53.title),
        "url": `https://${browserDetails === null || browserDetails === void 0 ? void 0 : browserDetails.host}${(_54 = pageMetaData === null || pageMetaData === void 0 ? void 0 : pageMetaData.path) !== null && _54 !== void 0 ? _54 : ""}`,
        "description": ((_56 = (_55 = pageMetaData === null || pageMetaData === void 0 ? void 0 : pageMetaData.page) === null || _55 === void 0 ? void 0 : _55.metadataMap) === null || _56 === void 0 ? void 0 : _56.description) || ((_57 = pageMetaData === null || pageMetaData === void 0 ? void 0 : pageMetaData.page) === null || _57 === void 0 ? void 0 : _57.title),
        "publisher": {
            "@type": "Organization",
            "name": publisher,
            "logo": {
                "@type": "ImageObject",
                "url": publisherLogo
            }
        }
    };
    const { VerticalMasthead, Masthead, isVerticalMasthead, originalPageData, pageDataClone, mastheadData, horizontalMasthead } = useMemo(() => {
        var _a, _b, _c, _d, _e;
        if (pageMetaData === null || pageMetaData === void 0 ? void 0 : pageMetaData.error) {
            return {};
        }
        const originalPageData = JSON.parse(JSON.stringify(pageMetaData === null || pageMetaData === void 0 ? void 0 : pageMetaData.page));
        const pageDataClone = JSON.parse(JSON.stringify(originalPageData));
        const mastheadData = (_a = originalPageData === null || originalPageData === void 0 ? void 0 : originalPageData.modules) === null || _a === void 0 ? void 0 : _a.filter(module => module.moduleType === "MastheadModule");
        const remainingData = (_b = originalPageData === null || originalPageData === void 0 ? void 0 : originalPageData.modules) === null || _b === void 0 ? void 0 : _b.filter(module => module.moduleType !== "MastheadModule");
        originalPageData.modules = remainingData;
        let isVerticalMasthead = false;
        let horizontalMasthead = false;
        if ((mastheadData === null || mastheadData === void 0 ? void 0 : mastheadData.length) > 0) {
            const placement = (_e = (_d = (_c = mastheadData[0]) === null || _c === void 0 ? void 0 : _c.layout) === null || _d === void 0 ? void 0 : _d.settings) === null || _e === void 0 ? void 0 : _e.navigationPlacement;
            if (placement === "Left") {
                isVerticalMasthead = true;
            }
            else {
                horizontalMasthead = true;
            }
        }
        return {
            VerticalMasthead: isVerticalMasthead ? VerticalMastheadComponent : null,
            isVerticalMasthead,
            Masthead: horizontalMasthead ? MastheadComponent : null,
            originalPageData,
            pageDataClone,
            horizontalMasthead,
            mastheadData
        };
    }, [pageMetaData === null || pageMetaData === void 0 ? void 0 : pageMetaData.page]);
    if (pageMetaData === null || pageMetaData === void 0 ? void 0 : pageMetaData.error) {
        return (React.createElement(Html, { "data-testid": "html", xApiKey: xApiKey, cachedAPI: cachedAPI, sseBaseUrl: sseBaseUrl, siteConfig: siteConfig, pageData: pageMetaData, browserDetails: browserDetails, title: (_58 = siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.appcmsMain) === null || _58 === void 0 ? void 0 : _58.site, apiBaseUrl: apiBaseUrl, analyticsBaseUrl: analyticsBaseUrl, wssBaseUrl: wssBaseUrl, env: env, ip: ip, embedCodeToken: embedCodeToken, toolsUrl: toolsUrl, templateUrl: templateUrl, requestId: requestId, cssHref: cssHref, scriptSrcs: scriptSrcs },
            React.createElement(Suspense, null,
                React.createElement(ErrorBoundary, { fallback: React.createElement("div", null, "Error loading component") },
                    React.createElement("div", { className: "main" },
                        React.createElement(NotFound404, null))))));
    }
    else {
        return (React.createElement(Html, { "data-testid": "html", xApiKey: xApiKey, cachedAPI: cachedAPI, sseBaseUrl: sseBaseUrl, siteConfig: siteConfig, pageData: pageMetaData, browserDetails: browserDetails, title: (_59 = siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.appcmsMain) === null || _59 === void 0 ? void 0 : _59.site, apiBaseUrl: apiBaseUrl, analyticsBaseUrl: analyticsBaseUrl, wssBaseUrl: wssBaseUrl, env: env, ip: ip, embedCodeToken: embedCodeToken, toolsUrl: toolsUrl, templateUrl: templateUrl, requestId: requestId, cssHref: cssHref, scriptSrcs: scriptSrcs },
            React.createElement(Suspense, null,
                React.createElement("noscript", { dangerouslySetInnerHTML: {
                        __html: `
              <style>
                .skip-nav-noscript {
                  position: static;
                  display: block;
                  background: #3c763d;
                  color: white;
                  padding: 10px;
                  text-decoration: underline;
                }
              </style>
              <a href="#main" class="skip-nav-noscript">Skip to main content</a>
            `,
                    } }),
                React.createElement(NavFocusSkipper, null),
                React.createElement("script", { type: "application/ld+json", dangerouslySetInnerHTML: { __html: JSON.stringify(pageSchema) } }),
                activeSplash ? React.createElement(SplashLoader, { name: activeSplash }) : false,
                React.createElement(PersonalizationBanner, null),
                React.createElement(CmsMenu, null),
                shouldShowLocationModal && React.createElement(LocationServicesModal, null),
                isUpgrade ? React.createElement(UpgradeWrapper, { metadataMap: "", isViewplans: false }) : React.createElement(React.Fragment, null),
                isTveEnabled && React.createElement(V2TveLogin, { previouslyFocusedElement: previouslyFocusedElement, type: "TveModule" }),
                isVerticalMasthead ? React.createElement(VerticalMasthead, { tabIndex: -1, pageData: (_60 = pageMetaData === null || pageMetaData === void 0 ? void 0 : pageMetaData.page) === null || _60 === void 0 ? void 0 : _60.modules, siteConfig: siteConfig, moduleData: mastheadData === null || mastheadData === void 0 ? void 0 : mastheadData[0] }) : React.createElement(React.Fragment, null),
                horizontalMasthead ? React.createElement(Masthead, { pageData: pageDataClone, siteConfig: siteConfig, moduleData: mastheadData === null || mastheadData === void 0 ? void 0 : mastheadData[0] }) : React.createElement(React.Fragment, null),
                React.createElement("main", { id: "main" },
                    React.createElement("div", { className: "modules-wrapper", style: isVerticalMasthead ? { marginLeft: '250px' } : {} },
                        SnackbarComponent && React.createElement(SnackbarComponent, { ref: snackbarRef }),
                        React.createElement(LazyLoadModules, { browserDetails: browserDetails, offset: 4, pageData: originalPageData, pathName: pageMetaData === null || pageMetaData === void 0 ? void 0 : pageMetaData.path, siteConfig: siteConfig }))),
                VLCookieConsent && !disableVlCookieConsent && React.createElement(VLCookieConsent, { genericMessage: configMessages }))));
    }
};
